<template>
	<div class="webContent flex" scroll @scroll="listenScroll">
		<div class="mine">
			<div class="area">
				<div class="user df hao">
					<div class="uname">{{user}}</div>
					<div class="point flex">积分：{{point}}</div>
					<div class="state state2" @click="showCancelFollow" v-if="isFollow">已关注</div>
					<div class="state" @click="followUser" v-else>关注</div>
				</div>
				<div class="duty">{{duty}}</div>
				<div class="social df hao">
					<div class="socialLi"><em>{{followCount}}</em>关注Ta的人</div>
					<div class="socialLi"><em>{{followCount2}}</em>Ta关注的人</div>
				</div>
				<div class="social2 df hao">
					<div class="socialLi2">得到<em>{{likeCount}}</em>点赞</div>
					<div class="socialLi3">已被<em>{{collectCount}}</em>次收藏</div>
				</div>
			</div>
			<div class="list">
				<div class="li" v-for="(v,i) in list" @click="toDetail(v)">
					<div class="cap df hao"><em>{{user}}</em>{{v.day}} · {{v.type=='question'?'发布了提问':'回答了问题'}}</div>
					<div class="item" v-for="(v2,i2) in v.item" v-if="v.type=='question'">
						<div class="title">{{v2.title}}</div>
						<div class="tool">{{v2.lastDate}} · {{v2.answerCount>0?v2.answerCount+'人回答':'暂无回答'}} · {{v2.followCount>0?v2.followCount+'人关注':'暂无关注'}}</div>
					</div>
					<div class="item2" v-for="(v2,i2) in v.item" v-else>
						<div class="title2"><i class="top"></i>{{v2.title}}</div>
						<div class="txt ov-4d" v-html="v2.txt">{{v2.txt}}</div>
						<div class="end df hao">
							<div class="like" :class="{ has: v2.question.approval!=0 }" @click.stop.prevent="likeItem(v2.question.id,v2.question.approval,v2.question)">{{v2.question.approvalTotal}}</div>
							<div class="collect" :class="{ has: v2.question.collection!=0 }" @click.stop.prevent="collectItem(v2.question.id,v2.question.collection,v2.question)">{{v2.question.collectionTotal}}</div>
							<div class="flex"></div>
							<div class="user2">{{v2.user}}</div>
							<div class="date">{{v2.date}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 取消关注 -->
		<div class="cancelFollow df wao hao" v-if="cancelFollow.has">
			<div class="cancelFollow-box">
				<div class="cancelFollow-txt">确认不再关注<em>{{cancelFollow.user}}</em>吗？</div>
				<div class="cancelFollow-end df war hao">
					<div class="cancelFollow-btn" @click="closeCancelFollow">放弃</div>
					<div class="cancelFollow-btn" @click="resCancelFollow">取消关注</div>
				</div>
			</div>
		</div>

		<!-- 收藏夹 -->
		<div class="collectBase" v-if="collectBase.has">
			<div class="collectBase-box">
				<div class="collectBase-top">
					<div class="collectBase-close" @click="closeCollectBase"></div>
					<span>已选择{{collectBase.choose.length}}个收藏夹</span>
					<div class="collectBase-add" @click="showCollectAddBase">新建收藏夹</div>
				</div>
				<div class="collectBase-list">
					<div class="collectBase-li df cf wao" :class="{ cur: collectBase.choose.indexOf(i)>=0 }" v-for="(v,i) in collectBase.list" @click="chooseCollectBase(i)">
						<div class="collectBase-title">{{v.name}}</div>
						<div class="collectBase-answer">{{v.answerTotal}}个回答</div>
					</div>
				</div>
				<div class="collectBase-btn" @click="resCollectBase">确认</div>
			</div>
		</div>

		<!-- 添加收藏夹 -->
		<div class="collectAddBase df wao hao" v-if="collectAddBase.has">
			<div class="collectAddBase-box">
				<div class="collectAddBase-input df hao">
					<input type="text" puc class="flex" placeholder="输入收藏夹标题" v-model="collectAddBase.val" @input="checkInput" />
					<i>{{13-collectAddBase.val.length}}</i>
				</div>
				<div class="collectAddBase-end df war hao">
					<div class="collectAddBase-btn" @click="resCollectAddBase">确认</div>
					<div class="collectAddBase-btn" @click="closeCollectAddBase">取消</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	let collect_obj = null;

	export default {
		name: 'me_user_page',
		data () {
			return {
				user: '',
				duty: '',
				isFollow: false,
				point: 0,
				followCount: 0,
				followCount2: 0,
				likeCount: 0,
				collectCount: 0,
				pagenum: 1,
				pagesize: 10,
				state: false,
				list: [],
				cancelFollow: {
					has: false,
					id: '',
					user: '',
				},
				collectBase: {
					id: '',
					index: null,
					has: false,
					choose: [],
					list: [],
				},
				collectAddBase: {
					has: false,
					val: '',
				},
			}
		},
		mounted(){
			this.uid = this.$route.query.id;

			this.getList();
		},
		methods: {
			dateTime(timestamp){
				if(!timestamp){ return ''; }
				var date = new Date(timestamp);
				var year = date.getFullYear();
				var month = date.getMonth()+1;
				var day = date.getDate();
				month = (month<10?'0':'')+month;
				day = (day<10?'0':'')+day;
				return year+'-'+month+'-'+day;
			},
			returnRetDate(timestamp){
				if(!timestamp){ return ''; }
				var nowDateStamp = new Date().getTime();
				var k = nowDateStamp-timestamp;
				if(k<60*60*1000){ // 1小时内
					var t = parseInt(k/(60*1000));
					return (t<5?'刚刚':t+'分钟前');
				}else if(k<24*60*60*1000){ // 24小时内
					return parseInt(k/(60*60*1000))+'小时前';
				}

				var date = new Date(timestamp);
				var year = date.getFullYear();
				var month = date.getMonth()+1;
				var day = date.getDate();
				month = (month<10?'0':'')+month;
				day = (day<10?'0':'')+day;
				return year+'-'+month+'-'+day;
			},
			listenScroll(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData();
				}
			},
			addMoreData() { //加载更多
				if(this.state){
					return false;
				}
				this.pagenum ++;
				this.getList();
			},
			getList(){
				this.state = true;

				this.h5Ajax('get','$/user/detail/'+this.uid,{
					page: this.pagenum,
					size: this.pagesize,
				}).then(r=>{
					this.user = r.name;
					this.isFollow = (r.attention);
					this.duty = r.post||'';
					this.point = r.integration;
					this.followCount = r.userCount.userConcernedTotal;
					this.followCount2 = r.userCount.attentionUserTotal;
					// this.likeCount = r.userCount.userApprovaledTotal||0; // 被点赞总数
					this.likeCount = (r.userCount.answerApprovaledTotal||0)+(r.userCount.questionApprovaledTotal||0)+(r.userCount.userApprovaledTotal||0); // 被点赞总数(发表的答案被点赞总数+发表的问题被点赞总数+个人被点赞总数)
					// this.collectCount = r.userCount.userFavoritedTotal||0; // 被收藏总数
					this.collectCount = (r.userCount.answerFavoritedTotal||0)+(r.userCount.questionFavoritedTotal||0)+(r.userCount.userFavoritedTotal||0); // 被收藏总数(发表的答案被收藏总数+发表的问题被收藏总数+个人被收藏总数)
					if(r.events.content.length>0){
						for(var i in r.events.content){
							var d = r.events.content[i];
							d.answer = d.answer||{};
							var k = {
								day: this.returnRetDate(d.types==1?d.question.createTime:d.answer.createTime),
								type: (d.types==1?'question':'answer'),
								questionId: d.question.id,
								item: [{
									title: d.question.title,
									answerCount: d.question.answerTotal,
									followCount: d.question.attentionTotal,
									lastDate: this.dateTime(d.question.createTime),
									txt: d.question.content,
									user: (d.question.creatorName||''),
									date: this.dateTime(d.question.createTime),
									question: d.question,
									answer: d.answer,
								}],
							};
							this.list.push(k)
						}
						this.state = false;
					}

					this.cancelFollow = {
						has: false,
						id: r.attention,
						user: r.name,
					};
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			followUser(){
				this.h5Ajax('post','$/attentions/add',{
					attentionId: this.uid,
					types: 3,
				}).then(r=>{
					// this.pagenum = 1;
					// this.state = false;
					// this.list = [];
					// this.getList();
					this.isFollow = true;
					this.followCount ++;
					this.cancelFollow.id = r.id;
				})
			},
			showCancelFollow(){
				this.cancelFollow.has = true;
			},
			closeCancelFollow(){
				this.cancelFollow.has = false;
			},
			resCancelFollow(){
				this.h5Ajax('post','$/attentions/cancel',{
					id: this.cancelFollow.id,
				}).then(r=>{
					this.cancelFollow.has = false;
					// this.pagenum = 1;
					// this.state = false;
					// this.list = [];
					// this.getList();
					this.isFollow = false;
					this.followCount --;
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			collectItem(id,wid,item){
				collect_obj = item;
				if(wid>0){
					this.h5Ajax('post','$/collections/cancel',{
						id: wid,
					}).then(r=>{
						// this.pagenum = 1;
						// this.state = false;
						// this.list = [];
						// this.getList();
						item.collection = 0;
						item.collectionTotal --;
					}).catch(err => {
						console.error('err:' + err)
					})
				}else{
					this.collectBase = {
						id: id,
						index: 1,
						has: true,
						choose: [],
						list: [],
					};

					this.getCollectList();
				}
			},
			getCollectList(){
				this.h5Ajax('get','$/favorites/listByUid',{
					personal: 0,
				}).then(r=>{
					this.collectBase.choose = [];
					this.collectBase.list = r;
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			closeCollectBase(){
				this.collectBase.has = false;
			},
			resCollectBase(){
				if(this.collectBase.choose.length==0){
					alert('请选择收藏夹');
					return;
				}

				var fid = this.collectBase.list[this.collectBase.choose].id;

				this.h5Ajax('post','$/collections/add',{
					collectionId: this.collectBase.id,
					favoriteId: fid,
					types: 1,
				}).then(r=>{
					this.collectBase.has = false;
					// this.pagenum = 1;
					// this.state = false;
					// this.list = [];
					// this.getList();
					collect_obj.collection = r.id;
					collect_obj.collectionTotal ++;
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			showCollectAddBase(){
				this.collectAddBase = {
					has: true,
					val: '',
				}
			},
			closeCollectAddBase(){
				this.collectAddBase.has = false;
			},
			resCollectAddBase(){
				this.h5Ajax('post','$/favorites/add',{
					name: this.collectAddBase.val,
					personal: 0,
				}).then(r=>{
					this.collectAddBase.has = false;
					this.getCollectList();
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			chooseCollectBase(index){
				// if(this.collectBase.choose.indexOf(index)>=0){
				// 	this.collectBase.choose.splice(this.collectBase.choose.indexOf(index),1);
				// }else{
				// 	this.collectBase.choose.push(index);
				// }
				if(this.collectBase.choose[0]==index){
					this.collectBase.choose = [];
				}else{
					this.collectBase.choose = [index];
				}
			},
			checkInput(){
				if(this.collectAddBase.val.length>13){
					this.collectAddBase.val = this.collectAddBase.val.substring(0,13);
				}
			},
			likeItem(id,wid,item){
				if(wid>0){
					this.h5Ajax('post','$/approvals/cancel',{
						id: wid,
					}).then(r=>{
						// this.pagenum = 1;
						// this.state = false;
						// this.list = [];
						// this.getList();
						item.approval = 0;
						item.approvalTotal --;
					})
				}else{
					this.h5Ajax('post','$/approvals/add',{
						approvalId: id,
						types: 1,
					}).then(r=>{
						// this.pagenum = 1;
						// this.state = false;
						// this.list = [];
						// this.getList();
						item.approval = r.id;
						item.approvalTotal ++;
					})
				}
			},
			toDetail(data){
				this.$router.replace({ path: '/model/detail', query: { id: data.questionId } });
			},
		},
	}
</script>

<style scoped>
	@import './user'
</style>



// WEBPACK FOOTER //
// src/app/pages/me/user/user.vue